/*
 * @Description: URL集合
 * @Author: tongjunyi<tongjunyi@didiglobal.com>
 * @Date: 2023-04-19 14:41:44
 * @LastEditors: tongjunyi
 * @LastEditTime: 2023-11-18 13:39:13
 */
export const API_URL = {
  GetUserAuth: '/web/auth/getUserAuth', // 获取用户权限
  GetCsUrl: '/web/common/getCxPlatformLink', // 获取客服hc页面链接
  GetFilterList: '/web/order/getFilterList', // 获取筛选条件下拉框
  GetOrderSummary: '/web/order/getOrderSummary', // 查询订单汇总
  GetOrderList: '/web/order/getOrderList', // 根据检索条件获取订单
  GetBillList: '/web/bill/getBillList', // 查询账单
  ExportBill: '/web/bill/exportBillSummary', // 导出订单汇总
  ExportOrder: '/web/bill/exportBill', // 导出订单详情
  // 油站改价页
  GetDiscountSettingList: '/web/discountManage/getDiscountSettingList', // 获取油站折扣列表
  GetDiscountSettingDetail: '/web/discountManage/getDiscountSettingDetail', // 获取折扣详情
  SaveDiscount: '/web/discountManage/saveDiscount', // 保存油站折扣
  UpdateProduct: '/web/discountManage/updateProduct', // 油品上下架
  DownloadDiscountTemplate: '/web/discountManage/downloadDiscountTemplate', // 下载折扣修改模板
  ValidateDiscountTemplate: '/web/discountManage/validateDiscountTemplate', // 校验折扣修改excel
  GetProductInfoList: '/web/discountManage/getProductInfoList', // 批量修改折扣预览
  BatchSaveDiscount: '/web/discountManage/batchSaveDiscount', // 二次确认修改折扣&消息触达
  GetDiscountManageSwitch: '/web/discountManage/getDiscountManageSwitch', // 批量开关

  // 油站修改记录页
  GetDiscountRecords: '/web/discountManage/getDiscountRecords', // 获取油站折扣调整记录
  GetDiscountRecordDetail: '/web/discountManage/getDiscountRecordDetail', // 获取油站折扣记录详情
  // 对账结算模块
  GetSettlementBillList: '/web/settlement/getBillList', // 账单结算列表
  GetBillDetail: '/web/settlement/getBillDetail', // 账单结算详情
  GetDebitNoteList: '/web/settlement/getDebitNoteList', // 账单凭证列表
  GetApprovalDetail: '/web/settlement/getApprovalDetail', // 审批详情
  UploadFile: '/web/common/uploadFile', // 上传文件到gift
  UpdateDebitNote: '/web/settlement/updateDebitNote', // 更新账单凭证
  UploadDebitNote: '/web/settlement/uploadDebitNote', // 上传账单凭证文件流
  UpdateSupportFile: '/web/settlement/updateSupportFile', // 上传支持性文件
  ConfirmBill: '/web/settlement/confirmBill', // 账单确认
  AdjustBillAmount: '/web/settlement/adjustBillAmount', // 调整金额
  WithdrawAdjustBillAmount: '/web/settlement/withdrawAdjustBillAmount', // 调整金额撤回
  // 对账结算二期
  GetAdjustAmountDetail: '/web/settlement/getAdjustAmountDetail', // 获取账单调整金额详情
  SaveExpectedAmount: '/web/settlement/saveExpectedAmount', // 编辑油站期望金额
  SaveTemp: '/web/settlement/saveTemp', // 暂存调整金额信息
  CalculateBillAmount: '/web/settlement/calculateBillAmount' // 调整金额页金额计算
};

export default {};
